import React from 'react';
import { styled } from '@teko/ui';
import { LogoLoading } from '../Loading/LogoLoading.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div`
  position: relative;
  border-radius: 0.5rem;
  background: #fff;
  height: ${(props) => props.height + "px"};
  user-select: none;
`;
const StyledLogoLoading = styled(LogoLoading)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;
const PreLoad = (_a) => {
  var _b = _a, {
    height,
    isLoading,
    hideLogo = false,
    logo
  } = _b, props = __objRest(_b, [
    "height",
    "isLoading",
    "hideLogo",
    "logo"
  ]);
  if (!isLoading)
    return null;
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    height
  }), !hideLogo && /* @__PURE__ */ React.createElement(StyledLogoLoading, {
    logo
  }));
};

export { PreLoad };
